<template>
    <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="md-layout">
                <div class="md-layout-item">
                    <div class="card-icon">
                        <font-awesome-icon class="md-icon" :icon="['fas', 'clipboard-list']"/>
                    </div>
                </div>
            </div>
        </md-card-header>
        <md-card-content>
            <div>
                <span class="font-bold">Filtres</span>
            </div>
            <div class="flex items-center mb-2">
                <div class="mr-4" style="min-width: 150px;">
                    <md-field>
                        <md-select v-model="filter.year" name="year" id="year">
                            <md-option v-for="(year, index) in filter.years" :key="index" :value="year">
                                {{ year }}
                            </md-option>
                        </md-select>
                    </md-field>
                </div>
                <div class="mr-6" style="min-width: 200px;">
                    <md-field>
                        <md-select v-model="filter.month" name="month" id="month">
                            <md-option :value="0">Janvier</md-option>
                            <md-option :value="1">Février</md-option>
                            <md-option :value="2">Mars</md-option>
                            <md-option :value="3">Avril</md-option>
                            <md-option :value="4">Mai</md-option>
                            <md-option :value="5">Juin</md-option>
                            <md-option :value="6">Juillet</md-option>
                            <md-option :value="7">Août</md-option>
                            <md-option :value="8">Septembre</md-option>
                            <md-option :value="9">Octobre</md-option>
                            <md-option :value="10">Novembre</md-option>
                            <md-option :value="11">Décembre</md-option>
                        </md-select>
                    </md-field>
                </div>
                <md-button class="md-default md-dense" @click="updateBillFilter">Filtrer</md-button>
                <md-button class="md-default md-dense" @click="getCurrentContractsBills">Mois actuel</md-button>
            </div>
            <md-table class="paginated-table"
                      :value="contracts"
            >
                <md-table-toolbar>
                    <md-field>
                        <label for="pages">Éléments à afficher</label>
                        <md-select v-model="pagination.perPage" name="pages" id="pages">
                            <md-option
                                v-for="item in pagination.perPageOptions"
                                :key="item" :label="item" :value="item">
                                {{ item }}
                            </md-option>
                        </md-select>
                    </md-field>

                    <search-input @input="inputSearch"></search-input>
                </md-table-toolbar>

                <md-table-row slot="md-table-row" slot-scope="{ item }" :class="item.bills.length > 0 ? 'row-success' : 'row-danger'">
                    <md-table-cell md-label="Informations intervention" class="cell-bill-info">
                        <div class="billing-indicator"></div>
						<div class="pl-2">
                            <div>
                                Contrat {{'#' + item.id + ' (' + item.number +')'}}
                            </div>
                            <div v-if="item.last_period.cancel_date" class="text-danger">
                                CONTRAT RESILIE le {{$moment(item.last_period.cancel_date).format('DD/MM/YYYY')}}
                            </div>
                            <div v-if="(!item.is_tacit && $moment((item.current_period ? item.current_period.date_end : item.last_period.date_end)).add(item.days_notice, 'd').isBefore($moment()))"
                                 class="text-warning">
                                DATE ECHEANCE PASSEE
                            </div>
                        </div>
                    </md-table-cell>
                    <md-table-cell md-label="Code EBP / Client" style="max-width: 200px;">
                        <span class="text-info cursor-pointer"
                              @mousedown="goToRoute($event, 'Client Details', { id: item.site.client.id })">
							{{ item.site.client.code_ebp + ' / ' + item.site.client.name }}
						</span>
                    </md-table-cell>
                    <md-table-cell md-label="Site">
                        <span class="text-info cursor-pointer"
                              @mousedown="goToRoute($event, 'Site Details', { id: item.site.client.id, idSite: item.site.id })">
                            {{item.site.name }}
						</span>
                    </md-table-cell>
                    <md-table-cell md-label="N° contrat (type)">
                          <div class="font-medium">{{item.number}}</div>
                          <div>{{ 'Début contrat: ' + $moment(item.first_period.date_start).format('DD/MM/YYYY') }}</div>
                    </md-table-cell>
                    <md-table-cell md-label="Type" style="max-width: 150px;">
                        <div>{{ getInterventionTypes(item) }}</div>
                        <div>(contrat)</div>
                    </md-table-cell>
                    <md-table-cell md-label="" style="max-width: 325px;" v-if="item.isSaved">
                        <div>
                            Facture n°{{ item.bills[0].number }} du {{ $moment(item.bills[0].date).format('DD/MM/YYYY') }} saisie par {{ item.bills[0].creator.first_name }}
                            <br>
                            {{ item.bills[0].comment ? ('(' + item.bills[0].comment + ')') : '' }}
                        </div>
                        <div class="my-auto ml-4">
                            <md-button class="md-icon-button md-danger" @click="deleteBill(item.bills[0].id)">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'trash']" />
                            </md-button>
                        </div>
                    </md-table-cell>
                    <md-table-cell md-label="" style="max-width: 325px; width: 325px;" v-else-if="!item.bills[0]">
                        <div>
                            <div class="flex mt-0">
                                <md-field class="md-invalid mr-3">
                                    <label :for="'number-'+item.id">Numéro facture</label>
                                    <md-input v-model="item.billNumber" type="text" :id="'number-'+item.id"></md-input>
                                </md-field>
                                <md-field class="md-invalid mr-3">
                                    <label :for="'date-'+item.id">Date facture</label>
                                    <md-input v-model="item.billDate" type="date" :id="'date-'+item.id"></md-input>
                                </md-field>
                            </div>
                            <md-field class="md-invalid mt-1">
                                <label :for="'comment-'+item.id">Commentaire facture</label>
                                <md-input v-model="item.billComment" type="text" :id="'comment-'+item.id"></md-input>
                            </md-field>
                        </div>
                        <div class="my-auto ml-4">
                            <md-button class="md-icon-button md-success" @click="saveBill(item)">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'save']" />
                            </md-button>
                        </div>
                    </md-table-cell>
                    <md-table-cell md-label="" style="max-width: 325px; width: 325px;" v-else>
                        <div>
                            <div class="flex mt-0">
                                <md-field class="md-invalid mr-3">
                                    <label :for="'number-'+item.id">numéro facture</label>
                                    <md-input v-model="item.bills[0].number" type="text" :id="'number-'+item.id"></md-input>
                                </md-field>
                                <md-field class="md-invalid mr-3">
                                    <label :for="'date-'+item.id">Date facture</label>
                                    <md-input v-model="item.bills[0].date" type="date" :id="'date-'+item.id"></md-input>
                                </md-field>
                            </div>
                            <md-field class="md-invalid mt-1">
                                <label :for="'comment-'+item.id">commentaire facture</label>
                                <md-input v-model="item.bills[0].comment" type="text" :id="'comment-'+item.id"></md-input>
                            </md-field>
                        </div>
                        <div class="my-auto ml-4">
                            <md-button class="md-icon-button md-success" @click="updateBill(item)">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'save']" />
                            </md-button>
                        </div>
                    </md-table-cell>
                </md-table-row>
            </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
            <p class="card-category">
                Affichage des éléments {{ from + 1 }} à {{ to }} sur {{ pagination.total }} éléments
            </p>
            <pagination
                class="pagination-no-border pagination-info"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
                @input="getContractsBills"
            >
            </pagination>
        </md-card-actions>
    </md-card>
</template>

<script>
import Pagination from "@/components/Pagination";
import {mapState} from "vuex";
import SearchInput from "@/components/Tables/SearchInput";
import routerMixin from '@/mixins/router-mixin';

export default {
    name: "ContractsIndex",
    components: {
        Pagination,
        SearchInput
    },
    mixins: [routerMixin],
    data() {
        return {
            contracts: [],
            pagination: {
                perPage: 50,
                currentPage: 1,
                perPageOptions: [25, 50, 100],
                total: 0
            },
            searchQuery: "",
            filter: {
                years: [],
                year: this.$moment().year(),
                month: this.$moment().month(),
            },
            wait: false
        }
    },
    methods: {
        inputSearch(e) {
            this.searchQuery = e
            this.getContractsBills()
        },
        async getContractsBills() {
            if (!this.wait) {
                this.wait = true
                const response = await this.$store.dispatch('bills/getContractBills', {
                    order: this.order,
                    page: this.pagination.currentPage,
                    perPage: this.pagination.perPage,
                    search: this.searchQuery,
                    year: this.filter.year,
                    month: this.filter.month,
                })
                this.$store.commit('profile/setFiltersData', {year: this.filter.year, month: this.filter.month})
                this.wait = false
                this.contracts = response.data.data
                this.pagination.total = response.data.total
            }
        },
        async getCurrentContractsBills() {
            this.filter.year = this.$moment().year()
            this.filter.month = this.$moment().month()
            await this.getContractsBills()
        },
        async updateBillFilter() {
            if (!this.wait) {
                this.wait = true
                await this.$store.dispatch('bills/updateBillFilter', {
                    year: this.filter.year,
                    month: this.filter.month,
                })
                this.wait = false
            }
            await this.getContractsBills()
        },
        async deleteBill(id) {
            if (!this.wait) {
                this.wait = true
                await this.$store.dispatch('bills/deleteBill', {
                    billId: id,
                })
                this.wait = false
            }
            await this.getContractsBills()
        },
        async updateBill(item) {
            if (!this.wait) {
                this.wait = true
                await this.$store.dispatch('bills/updateBill', {
                    billId: item.bills[0].id,
                    number: item.bills[0].number,
                    comment: item.bills[0].comment,
                    date: item.bills[0].date,
                })
                this.wait = false
            }
            await this.getContractsBills()
        },
        async saveBill(item) {
            if (!this.wait) {
                this.wait = true
                await this.$store.dispatch('bills/saveContractBill', {
                    contractId: item.id,
                    number: item.billNumber,
                    comment: item.billComment,
                    date: item.billDate,
                    year: this.filter.year,
                    month: this.filter.month,
                })
                this.wait = false
            }
            await this.getContractsBills()
        },
        getInterventionTypes(item) {
            return item.intervention_plan.planning_intervention_groups.map(group => group.intervention_type.name).join(', ')
        },
        formatYearFilter() {
            for(let i = -5; i <= 4; i++) {
                this.filter.years.push((this.$moment().year() + i))
            }
        }
    },
    computed: mapState({
        user: state => state.profile.me,
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.pagination.total < highBound) {
                highBound = this.pagination.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.pagination.total;
        },
    }),
    mounted() {
        this.getContractsBills()
        this.formatYearFilter()
        if (this.user.data && JSON.parse(this.user.data).factu_date) {
            let date = this.$moment(JSON.parse(this.user.data).factu_date, 'M-YYYY');
            this.filter.year = date.year()
            this.filter.month = date.month()
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-table {
        .md-table-row {
            .cell-bill-info {
                .md-table-cell-container {
                    position: relative;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    .billing-indicator {
                        position: absolute;
                        top: 0;
                        left: -5px;
                        height: 100%;
                        min-height: 37px;
                        width: 5px;
                        z-index: 100;
                        border-radius: 2px;
                    }
                }
            }
            &.row-danger {
                .billing-indicator {
                    background: $brand-danger;
                }
            }
            &.row-success {
                .billing-indicator {
                    background: $brand-success;
                }
            }
        }
        .md-table-cell-container .md-button {
            width: auto;

            .md-icon {
                font-size: .875rem !important;
                min-width: .875rem !important;
                height: .875rem !important;
            }
        }
    }
}
</style>
